import React from "react";
import { inCls, Field } from "./shared";

export default function CompanyStep({ data, onChange, firstFieldRef }) {
  const set = (k) => (e) => onChange({ ...data, [k]: e.target.value });
  return (
    <>
      <Field id="onb-activite" label="Secteur d'activité" required>
        <input id="onb-activite" ref={firstFieldRef} type="text" value={data.activite || ""} onChange={set("activite")} className={inCls} placeholder="Ex. Cabinet spécialisé en implantologie et parodontie" />
      </Field>
      <Field id="onb-legal-form" label="Forme juridique">
        <input id="onb-legal-form" type="text" value={data.legal_form || ""} onChange={set("legal_form")} className={inCls} placeholder="Ex. SARL, SAS..." />
      </Field>
      <Field id="onb-headcount" label="Effectif">
        <input id="onb-headcount" type="text" value={data.headcount || ""} onChange={set("headcount")} className={inCls} placeholder="Ex. 1-10 employés" />
      </Field>
      <Field id="onb-directors" label="Dirigeant(s)">
        <input id="onb-directors" type="text" value={data.directors || ""} onChange={set("directors")} className={inCls} />
      </Field>
      <Field id="onb-siret" label="SIRET / n° d'immatriculation">
        <input id="onb-siret" type="text" value={data.siret || ""} onChange={set("siret")} className={inCls} />
      </Field>
    </>
  );
}
